import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { GetDesignationsApi } from "../../../api/GetDesignationsApi";

import { GetUnitsApi } from "../../../api/GetUnitsApi";
import { GetUserRoleApi } from "../../../api/user-role/GetUserRoleApi";
const { Option } = Select;

function IndividualPerformanceFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [designations, setDesignations] = useState();
  const [units, setUnits] = useState();
  const [roles, setRoles] = useState();
  const [form] = Form.useForm();

  function handleCancel() {
    props.handleCancel();
    setSubmit(false);
    form.resetFields();
  }

  useEffect(() => {
    if (props.visible) {
      getDesignations();
      getUnits();
      getRoles();
    }
  }, [props.visible]);

  async function getDesignations() {
    const apiResponse = await GetDesignationsApi();

    if (apiResponse.message === "success") {
      setDesignations(apiResponse.designations);
      props.filterBy?.designation &&
        form.setFields([
          {
            name: "designation",
            value: props.filterBy?.designation,
          },
        ]);
    }
  }

  async function getUnits() {
    const apiResponse = await GetUnitsApi();
    if (apiResponse.message === "success") {
      setUnits(apiResponse.units);
      props.filterBy?.unit &&
        form.setFields([
          {
            name: "unit",
            value: props.filterBy?.unit,
          },
        ]);
    }
  }

  async function getRoles() {
    const apiResponse = await GetUserRoleApi();
    if (apiResponse.message === "User roles") {
      setRoles(apiResponse.data);
      props.filterBy?.role &&
        form.setFields([
          {
            name: "role",
            value: props.filterBy?.role,
          },
        ]);
    }
  }

  function onFinish(values) {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  }
  return (
    <Modal
      title="Filter Positions"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="Individuals Filter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Designation" name="designation">
          <Select placeholder="Select designation">
            {designations?.map((designation) => {
              return (
                <Option key={designation.id} value={designation.id}>
                  {designation.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item label="Unit" name="unit">
          <Select placeholder="Select units">
            {units?.map((unit) => {
              return (
                <Option key={unit.id} value={unit.id}>
                  {unit.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item label="Role" name="role">
          <Select placeholder="Select role">
            {roles?.map((role) => {
              return (
                <Option key={role.id} value={role.id}>
                  {role.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default IndividualPerformanceFilterModal;
